import { Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  INTEGRATION_CONNECTION_STATE_CONNECTED,
  INTEGRATION_CONNECTION_STATE_DISCONNECTED,
  INTEGRATION_CONNECTION_STATE_UNSTABLE,
} from '../../constants.ts';
import { Territory } from '../../schema/Territory.ts';
import { useAllTerritories } from '../../services/Territory.ts';
import { CustomSpinner } from '../ui/Spinner.tsx';

export function Territories() {
  const { t } = useTranslation();
  const { data: territories, isLoading: territoriesLoading, error } = useAllTerritories();

  const navigate = useNavigate();

  const onClick = (territory: Territory) => {
    navigate(`dashboard/${territory.slug}/`);
  };

  function getBadgeStyle(territory: Territory) {
    let style = { backgroundColor: '#FFE5E5', color: '#D3180C' };
    if (isTerritoryActive(territory)) {
      style = { backgroundColor: '#ECFCE5', color: '#198155' };
    }
    return style;
  }
  function isTerritoryActive(territory: Territory) {
    return (
      territory.integration_state_counts[INTEGRATION_CONNECTION_STATE_CONNECTED] > 0 ||
      territory.integration_state_counts[INTEGRATION_CONNECTION_STATE_UNSTABLE] > 0
    );
  }
  function getIntegrationStateText(territory: Territory) {
    return (
      territory.integration_state_counts[INTEGRATION_CONNECTION_STATE_CONNECTED] +
      ' connected, ' +
      territory.integration_state_counts[INTEGRATION_CONNECTION_STATE_UNSTABLE] +
      ' unstable, ' +
      territory.integration_state_counts[INTEGRATION_CONNECTION_STATE_DISCONNECTED] +
      ' disconnected'
    );
  }

  return (
    <div>
      <h1 className={'text-center territory-page-title mt-5'}>{t('homepage.title')}</h1>
      <div className={'row d-flex mb-5 me-5 ms-5 pb-5'}>
        {territoriesLoading ? (
          <CustomSpinner class={'text-center mt-5 pt-5'} size={undefined} />
        ) : (
          <>
            {error ? (
              <p className={'text-center mt-5'}>{t('homepage.territory-error')}</p>
            ) : territories?.length ? (
              territories.map((territory: Territory) => (
                <div className={'col-md-6 col-xl-4'} key={territory.id}>
                  <Card
                    className={'text-center pb-3 border-0 rounded-3 basic-shadow gx-5 mt-5 ms-3 me-3'}>
                    <div className={'text-end me-3 mt-3'}>
                      <p
                        style={getBadgeStyle(territory)}
                        className={'badge rounded-pill text-basic'}
                        title={getIntegrationStateText(territory)}>
                        {isTerritoryActive(territory)
                          ? t('homepage.territory-enabled')
                          : t('homepage.territory-disabled')}
                      </p>
                    </div>
                    <h1 className={'territory-name-text mt-4'}>{territory.slug}</h1>
                    <Button
                      onClick={() => onClick(territory)}
                      disabled={!isTerritoryActive(territory)}
                      className={'submit-button m-auto ps-5 pe-5 mt-4'}>
                      Dashboard
                    </Button>
                    <hr className={'w-50 m-auto mt-3'} />
                    {territory?.config?.url?.map((url: string) => (
                      <a
                        key={url}
                        className={'text-hyperlink mt-4'}
                        target="_blank"
                        href={url}
                        rel="noreferrer">
                        {url}
                      </a>
                    ))}
                  </Card>
                </div>
              ))
            ) : (
              <p className={'text-center mt-5'}>{t('homepage.no-territory-found')}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
